import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=5574f1b2&scoped=true"
import script from "./BankAccount.vue?vue&type=script&lang=js"
export * from "./BankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5574f1b2",
  null
  
)

export default component.exports